<template>
  <!-- 添加 ref 替代 document.querySelector，精准定位当前组件元素 -->
  <div class="header-wrap" ref="headerRef">
    <div class="header-mask abs" v-if="scrollPosition === 0"></div>
    <el-row :align="'middle'" class="header-items">
      <el-col :span="2" style="text-align: left">
        <KyIcon :type="hasHistory ? 'back' : 'home'" size="20" @click="back" />
      </el-col>
      <el-col :span="10">
        <p class="header-title" style="text-align: left">
          {{ title }}
        </p>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, defineProps, computed, watch, onUnmounted } from "vue";
import KyIcon from "@/components/KyIcon";
import { ElRow, ElCol } from "element-plus"; // 确保引入Element组件

// 1. 定义Props：明确类型和默认值，兼容多父组件传参
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  userJoin: {
    type: Function,
    default: () => {}, // 避免未传函数时调用报错
  },
  userForm: {
    type: Object,
    default: () => ({
      username: "",
      phone: 0,
      area: "",
      address: "",
      code: 0,
    }),
  },
  canSubmit: {
    type: Boolean,
    default: false,
  },
  scrollPosition: {
    type: Number,
    default: 0, // 父组件未传时默认0，避免NaN
  },
});

// 2. 替代this.$router和this.$refs
const router = useRouter();
const headerRef = ref(null); // 精准定位当前组件的.header-wrap

// 4. 计算属性：修复逻辑，支持渐变动画
const hasHistory = computed(() => {
  // 可选链避免window.history.state为undefined
  return window.history.state.back;
});

// 修复scrollValue：改为“滚动距离→动画进度”的映射（0~1），支持渐变
const scrollProgress = computed(() => {
  const maxScroll = 300; // 滚动300px后完全变白（可根据需求调整）
  return Math.min(props.scrollPosition / maxScroll, 1); // 限制在0~1之间
});

// 5. 方法（替代methods）
const back = () => {
  if (hasHistory.value) {
    router.go(-1);
  } else {
    router.push({ name: "Home" });
  }
};

// 6. 监听滚动位置：控制动画播放/进度，修复复用问题
watch(
  () => props.scrollPosition,
  () => {
    const headerEl = headerRef.value;
    if (!headerEl) return;

    // 核心：根据滚动进度控制背景渐变（两种方案可选，推荐方案2）
    // 方案1：用CSS变量控制动画（保留原动画逻辑，修复延迟问题）
    // headerEl.style.setProperty("--progress", scrollProgress.value);

    // 方案2：直接控制backgroundColor（性能更优，无动画延迟问题）
    headerEl.style.backgroundColor = `rgba(255, 255, 255, ${scrollProgress.value})`;
    // 可选：滚动时添加阴影，增强视觉
    headerEl.style.boxShadow =
      scrollProgress.value > 0 ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none";
  },
  { immediate: true } // 初始化时执行，避免初始状态异常
);

// 7. 组件卸载：清理样式，避免影响其他组件
onUnmounted(() => {
  const headerEl = headerRef.value;
  if (headerEl) {
    headerEl.style.backgroundColor = "transparent";
    headerEl.style.boxShadow = "none";
  }
});
</script>

<style scoped>
.header-wrap {
  --delay: 0s;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 99;
  max-width: 750px;
  height: 50px;
  background-color: transparent;
  color: #000;
  padding: 0 2%;
  /* 优化动画：统一时长，支持平滑过渡（方案2用transition更优） */
  transition: backgroundColor 0.3s ease, box-shadow 0.3s ease;
  /* 移除原冲突动画（方案1用动画时保留，方案2用transition可删除） */
  /* animation: headerScroll 0.3s linear forwards; */
}

/* 方案1：若用动画，修复关键帧（配合--progress变量） */
/* @keyframes headerScroll {
  to {
    background-color: rgba(255, 255, 255, var(--progress));
  }
} */

.header-items {
  position: relative;
  z-index: 1;
  height: 50px;
  margin: 0; /* 清除默认margin，避免布局偏移 */
}

.header-title {
  font-size: 18px;
  text-align: left; /* 与模板style一致，避免冲突 */
  margin: 0; /* 清除p标签默认margin */
}

.header-mask {
  width: 100%;
  height: 100%;
  z-index: 1;
}

.abs {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
